/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsHideWhenIntegrated', zcsHideWhenIntegrated);

zcsHideWhenIntegrated.$inject = ['$stateParams', 'Devise', 'ZcsProject'];
function zcsHideWhenIntegrated($stateParams, Devise, ZcsProject) {
  return {
    restrict: 'A',
    link(scope, elem, attrs) {
      const className = 'hide-when-integrated';
      if(attrs.ngHide || attrs.ngShow) {
        console.warn(`${className} component contains ng-hide or ng-show attributes`, elem);
      }

      elem.addClass(className);

      const { apikey } = $stateParams;
      if(!apikey) {
        return;
      }

      const integratedCarts = attrs.zcsHideWhenIntegrated.split(',');

      return Devise.getCurrentUser()
        .then(user => ZcsProject.get(user.id, apikey))
        .then(project => {
          if(integratedCarts.includes(project.integrated_with)) {
            return;
          }

          elem.removeClass(className);
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_hide_when_integrated/zcs_hide_when_integrated.directive.js